var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"size":_vm.size}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18 18 6M6 6l12 12"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }